import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProcessingStatusModelsComponent } from './component/processing-status-models/processing-status-models.component';
import { MaterialModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ColorPickerModule } from 'src/tmc-common/components/color-picker/color-picker.module';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  declarations: [
    ProcessingStatusModelsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DictionaryModule,
    CommonTranslationModule,
    ColorPickerModule,
    ApplicationClientCommonModule
  ]
})
export class ProcessingStatusModelsModule { }

